import React from "react";
import EnergyChart from "./EnergyChart";
import apiProxy from "../../api/apiProxy";

const loadStoreOpeningHours = apiProxy.store.getOpeningHours;
const loadLightsOverThresholdAlertThresholds =
  apiProxy.sensor.getLightsOverThresholdAlertThrehsolds;
const loadHvacOverThresholdAlertThresholds =
  apiProxy.sensor.getHvacOverThresholdAlertThresholds;
const loadAlertEvents = apiProxy.sensor.getAlertEventsForSensor;

export default props => (
  <EnergyChart
    loadSensorData={props.loadSensorData}
    sensorDataResolution={props.sensorDataResolution}
    loadStoreOpeningHours={loadStoreOpeningHours}
    loadLightsOverThresholdAlertThresholds={
      loadLightsOverThresholdAlertThresholds
    }
    loadHvacOverThresholdAlertThresholds={loadHvacOverThresholdAlertThresholds}
    loadAlertEvents={loadAlertEvents}
    {...props}
  />
);
